import { astar } from '@0xtorch/core'
import { astar as viemAstar } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

type CreateAstarChainParameters = {
  client: Client
  explorer: Explorer
}

export const createAstarChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}): Chain =>
  createAstarChainCustom({
    client: createClient({
      chain: viemAstar,
      httpRpcs: astarHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Astar explorer',
      baseUrl: 'https://astar.blockscout.com',
      apiBaseUrl: 'https://astar.blockscout.com/api',
      proxyUrl,
    }),
  })

export const createAstarChainCustom = ({
  client,
  explorer,
}: CreateAstarChainParameters): Chain => ({
  id: 592,
  network: 'astar-evm',
  name: 'Astar (EVM)',
  nativeToken: {
    name: 'Astar',
    symbol: 'ASTR',
    decimals: 18,
    currency: astar,
  },
  wrappedTokenAddresses: new Set([
    '0x37795fdd8c165cab4d6c05771d564d80439cd093',
    '0xaeaaf0e2c81af264101b9129c00f4440ccf0f720',
    '0xecc867de9f5090f55908aaa1352950b9eed390cd',
  ]),
  explorer,
  client,
  blockTime: 12_000,
  coingeckoId: 'astar',
  defillamaId: 'astar',
})

export const astarHttpRpcs: HttpRpc[] = [
  {
    url: 'https://evm.astar.network/',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint is not working
  // {
  //   url: 'https://rpc.astar.network:8545',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint is not working
  // {
  //   url: 'https://getblock.io/nodes/bsc/',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // No archiving receipts
  // {
  //   url: 'https://1rpc.io/astr',
  //   getLogsIsUsable: false,
  //   getLogsMaxBlockRange: 0n,
  // },
  // No archiving receipts
  // {
  //   url: 'https://astar-mainnet.g.alchemy.com/v2/demo',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://astar.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1000n,
  },
  {
    url: 'https://astar-rpc.n.dwellir.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 5000n,
  },
  {
    url: 'https://astar.public.curie.radiumblock.co/http',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://astar.public.curie.radiumblock.co/ws',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const astarWebsocketRpcUrls: readonly string[] = [
  'wss://rpc.astar.network',
  'wss://astar.api.onfinality.io/public-ws',
  'wss://astar-rpc.n.dwellir.com',
]
